import { createReducer } from '@reduxjs/toolkit'
import { uniqBy } from 'lodash/fp'

import { User } from '@/model/user'
import { concatWithReplace } from '@/utils/array'

import { readAllNotifications } from './notification-actions'
import {
  readUsersByConversations,
  userNamespace,
} from './user-actions'

const initialState: {
  usersMap: Record<number, User[] | undefined>
} = {
  usersMap: {},
}

const reducer = createReducer(initialState, (builder) => {
  builder.addCase(readUsersByConversations.fulfilled, (draft, { meta: { arg }, payload }) => {
    const creatorId = arg.creatorId

    const existUsers = draft.usersMap[creatorId]
    if (existUsers) {
      draft.usersMap[creatorId] = concatWithReplace(
        existUsers,
        payload,
        (a, b) => a.uid === b.uid,
      )
    } else {
      draft.usersMap[creatorId] = payload
    }
  })

  builder.addCase(readAllNotifications.fulfilled, (draft, { meta: { arg }, payload }) => {
    const { creatorId } = arg
    const existUsers = draft.usersMap[creatorId]
    const newUsers = uniqBy(({ uid }) => (uid), payload.list.map(({ user }) => user))
    if (existUsers) {
      draft.usersMap[creatorId] = concatWithReplace(
        existUsers,
        newUsers,
        (a, b) => a.uid === b.uid,
      )
    } else {
      draft.usersMap[creatorId] = newUsers
    }
  })
})

export default { [userNamespace]: reducer }
